/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["#divicono[_ngcontent-%COMP%]:hover > #divdescarga[_ngcontent-%COMP%]{display:flex}#divicono[_ngcontent-%COMP%]:hover > #divicono[_ngcontent-%COMP%]{display:none}#divdescarga[_ngcontent-%COMP%]{display:none;position:absolute;top:0;left:0;bottom:0;width:100%}"];
export { styles as styles };
